import type { MenuLinkType } from '@/app/types/top-navigation';

export const MENU_LINK_LCV: MenuLinkType = {
  label: 'รถปิกอัพและรถอเนกประสงค์',
  href: 'https://www.isuzu-tis.com',
  target: '_blank',
};

export const MENU_LINK_CV: MenuLinkType = {
  label: 'รถบรรทุก',
  href: 'https://truck.isuzu-tis.com',
  target: '_blank',
};

export const NAV_INTEREST: MenuLinkType = {
  label: 'สนใจรถ',
  href: '/register',
};
